import React, { useState } from 'react';
import { Input } from './ui/input';
import { Textarea } from './ui/textarea';
import { Checkbox } from './ui/checkbox';
import { useToast } from '../hooks/use-toast';
import { Send } from 'lucide-react';
import { submitContact } from '../api';

const ContactForm = () => {
  const { toast } = useToast();
  const [form, setForm] = useState({ first: '', last: '', phone: '', email: '', message: '', subscribe: false });
  const [submitting, setSubmitting] = useState(false);

  const handle = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!form.first || !form.last || !form.email || !form.message) {
      toast({ title: 'A few fields need your touch', description: 'Please complete the required fields.' });
      return;
    }
    setSubmitting(true);
    try {
      await submitContact({
        firstName: form.first,
        lastName: form.last,
        phone: form.phone,
        email: form.email,
        message: form.message,
        subscribe: form.subscribe,
      });
      setForm({ first: '', last: '', phone: '', email: '', message: '', subscribe: false });
      toast({ title: 'Thank you — message received', description: 'We will be in touch soon to start the conversation.' });
    } catch (err) {
      toast({ title: 'Something went wrong', description: 'Please try again in a moment.' });
    } finally {
      setSubmitting(false);
    }
  };

  const fieldCls =
    'bg-transparent border-0 border-b border-[#D6CEE0] rounded-none px-0 h-12 text-[#241033] placeholder:text-[#A99BBD] focus-visible:ring-0 focus-visible:border-[#43265E] transition-colors font-light';

  return (
    <form onSubmit={onSubmit} className="space-y-7">
      <div className="grid sm:grid-cols-2 gap-7">
        <div>
          <label className="eyebrow text-[#7E5C9E] block mb-2">First Name*</label>
          <Input value={form.first} onChange={handle('first')} placeholder="Jane" className={fieldCls} />
        </div>
        <div>
          <label className="eyebrow text-[#7E5C9E] block mb-2">Last Name*</label>
          <Input value={form.last} onChange={handle('last')} placeholder="Doe" className={fieldCls} />
        </div>
      </div>
      <div className="grid sm:grid-cols-2 gap-7">
        <div>
          <label className="eyebrow text-[#7E5C9E] block mb-2">Phone</label>
          <Input value={form.phone} onChange={handle('phone')} placeholder="(000) 000-0000" className={fieldCls} />
        </div>
        <div>
          <label className="eyebrow text-[#7E5C9E] block mb-2">Email*</label>
          <Input type="email" value={form.email} onChange={handle('email')} placeholder="you@email.com" className={fieldCls} />
        </div>
      </div>
      <div>
        <label className="eyebrow text-[#7E5C9E] block mb-2">How can we be an answer?*</label>
        <Textarea
          value={form.message}
          onChange={handle('message')}
          placeholder="Tell us about the vision, the challenge, or the crossroads you are navigating..."
          rows={4}
          className="bg-transparent border-0 border-b border-[#D6CEE0] rounded-none px-0 text-[#241033] placeholder:text-[#A99BBD] focus-visible:ring-0 focus-visible:border-[#43265E] transition-colors font-light resize-none"
        />
      </div>
      <label className="flex items-center gap-3 cursor-pointer">
        <Checkbox
          checked={form.subscribe}
          onCheckedChange={(v) => setForm({ ...form, subscribe: !!v })}
          className="data-[state=checked]:bg-[#43265E] data-[state=checked]:border-[#43265E] border-[#B9A9CC]"
        />
        <span className="text-sm font-light text-[#6A6570]">Sign up for news and updates</span>
      </label>
      <button
        type="submit"
        disabled={submitting}
        className="btn-plum rounded-full px-9 py-3.5 text-sm tracking-luxe uppercase inline-flex items-center gap-2 disabled:opacity-60"
      >
        {submitting ? 'Sending...' : 'Submit'}
        <Send className="w-4 h-4" strokeWidth={1.5} />
      </button>
    </form>
  );
};

export default ContactForm;
